import { createAttribute } from "../../../../slices/attribute/createattribute/thunk";
import { updateAttribute } from "../../../../slices/attribute/updateattribute/thunk";

export const onSubmit =
  (
    dispatch,
    setLoading,
    navigate,
    isEdit,
    attribute,
    checked,
    mandatoryChecked,
    mandatoryCheckedSelfcare,
    mandatoryCheckedPersistence,
    toggle,
  ) =>
  (values) => {
    const jsonObj = AttributeJsonOnj(
      values,
      checked,
      mandatoryChecked,
      mandatoryCheckedSelfcare,
      mandatoryCheckedPersistence,
    );
    submitAttribute(
      jsonObj,
      dispatch,
      setLoading,
      navigate,
      isEdit,
      attribute,
      toggle,
    );
  };
export const submitAttribute = (
  jsonObj,
  dispatch,
  setLoading,
  navigate,
  isEdit,
  attribute,
  toggle,
) => {
  if (isEdit) {
    dispatch(updateAttribute(setLoading, attribute, jsonObj, navigate, toggle));
  } else {
    dispatch(createAttribute(jsonObj, setLoading, navigate, toggle));
  }
};

export const AttributeJsonOnj = (
  values,
  checked,
  mandatoryChecked,
  mandatoryCheckedSelfcare,
  mandatoryCheckedPersistence,
) => {
  const isListValueType = values?.valueType?.value === "list";

const valueArray =
  values?.attributeValue && values?.attributeValue?.map((item) => item.value);
const selfcareValueArray =
  values?.SelfcareAttribute &&
  values?.SelfcareAttribute?.map((item) => item.value);
const finalValuesArray = isListValueType
  ? valueArray?.length
    ? valueArray
    : []
  : selfcareValueArray?.length
    ? selfcareValueArray
    : valueArray?.length
      ? valueArray
      : [];
  const jsonObj = JSON.stringify({
    name: values?.name,
    description: values.description,
    type: values?.type.value,
    valueType: values?.valueType.value,
    listType:
      values?.listType?.value === "single"
      ? "singleSelect"
      : values?.listType?.value === "multi"
        ? "multiSelect"
        : "openList",
    default: values.defaultValue ? values.defaultValue.toString() : "0",
    minValue: values.minimumValue ? values.minimumValue.toString() : "0",
    // maxValue: values.maximumValue ? values.maximumValue.toString() : "50",
    maxValue:
      values?.maximumValue !== undefined && values?.maximumValue !== ""
        ? String(values.maximumValue)
        : ["string", "float64","integer"].includes(values?.valueType?.value)
          ? "50"
          : "0",
    sequenceValue: values.sequenceValue ? values.sequenceValue.toString() : "",
    values: finalValuesArray,
    searchable: checked,
    mandatory: mandatoryChecked,
    selfcareVisible: mandatoryCheckedSelfcare,
    ratedEventPersistance: mandatoryCheckedPersistence,
    ...(values?.networkField !== "" &&
      values?.type.value === "usage" && {
        networkField: values?.networkField?.map((item) => item?.value),
      }),
       categories: values?.category?.map((item) => item.value) || [],

  ...(values?.networkField !== "" &&
    values?.type.value === "usage" && {
      networkField: values?.networkField?.map((item) => item?.value),
    }),
  });
  return jsonObj;
};

export const navigateToAddAttribute = (navigate) => {
  navigate("/create-attribute");
};

